<template>
  <v-card class="mx-4" elevation="4">
    <v-btn small class="ma-0" @click="$router.back()" color="info" rounded outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn
    >
    <v-list-item three-line>
      <v-list-item-content>
        <div class="text-overline mb-4">Reporte titulaciones</div>
        <v-list-item-title class="text-h5 mb-1"> Reporte de Titulaciones por Programa </v-list-item-title>
      </v-list-item-content>

      <v-btn class="orange darken-4" dark tile @click="bajarExcel()">
        <v-icon left>mdi-download</v-icon>
        Descargar Excel
      </v-btn>
    </v-list-item>

    <div class="row px-8">
      <div class="col col-md-4 col-lg-3">
        <v-select
          v-model="gestion"
          :items="gestiones"
          label="Gestion:"
          :loading="loading_gestiones"
          style="z-index: 18" />
      </div>
      <div class="col col-md-8 col-lg-9">
        <v-combobox
          v-model="programa"
          :items="programas"
          label="Programa:"
          :loading="loading_programas"
          clearable
          style="z-index: 18" />
      </div>
      <!-- <div class="col">
                <v-select :items="[]" label="Sede:"/>
            </div> -->
    </div>

    <template>
      <v-data-table
        :fixed-header="true"
        :loading="isLoading"
        height="calc(var(--vh, 1vh) * 100 - 19.5rem)"
        width="300"
        :headers="headers"
        :items="datos"
        item-key="id"
        :items-per-page="500"
        dense
        disable-pagination
        hide-default-footer
        class="elevation-1"
        >
        <!-- <template v-slot:thead>
                    <thead>
                        <tr>
                            <th v-for="(header, index) in headers" :key="header.value"
                                :class="{ 'sticky-column': index < 3 }">
                                {{ header.text }}---
                            </th>
                        </tr>
                    </thead>
                </template> -->


      <template v-slot:no-data>
        No existe datos para mostrar
      </template>

        <template v-slot:item="{ item }">
          <tr>
            <td
              v-for="header in headers"
              :key="header.value"
              class="text-center"
              :class="typeof item[header.value] === 'string' ? 'headcol' : ''">
              <template v-if="typeof item[header.value] === 'boolean'">
                <v-icon :color="item[header.value] ? 'green' : 'red'">{{
                  item[header.value] ? 'mdi-check' : 'mdi-close'
                }}</v-icon>
              </template>
              <span v-else>{{ item[header.value] }}</span>
            </td>
          </tr>
        </template>

        <template v-slot:foot>
          <tfoot>
            <tr>
              <td colspan="4" class="text-right">TOTALES</td>
              <td v-for="header in headers.slice(4)" :key="header.value" class="text-center">
                {{ totales[header.value] }}
              </td>
            </tr>
          </tfoot>
        </template>
      </v-data-table>
    </template>
  </v-card>
</template>

<style>
@import './stilo.css';
</style>

<script>
import { getHeaders, getDatos, getGestiones, getProgramas, descargarExcel } from './index.js';

export default {
  components: {},
  data() {
    return {
      isLoading: false,
      headers: [],
      datos: [],
      totales: {},
      gestiones: [],
      programas: [],
      gestion: null,
      programa: null,
      loading_gestiones: false,
      loading_programas: false,
    };
  },
  watch: {
    gestion() {
      this.listarProgramas();
    },
    '$store.state.convenio': function () {
      if (this.$store.state.convenio) {
        this.listarProgramas();
      }
    },
    '$store.state.CARGO': function () {
      if (this.$store.state.CARGO) {
        this.listarProgramas();
      }
    },
    programa() {
      if (!this.programa) {
        this.datos = [];
        this.totales = {};
        return;
      }
      this.listarDatos();
    },
  },

  computed: {},
  methods: {
    bajarExcel() {
      descargarExcel(this.headers, this.datos, this.totales);
    },
    async listarGestiones() {
      this.programa = null;
      this.gestiones = [];
      this.loading_gestiones = true;
      const ges = await getGestiones(this);
      this.gestiones = ges;
      this.loading_gestiones = false;
    },
    async listarProgramas() {
      this.programa = null;
      this.programas = [];
      this.loading_programas = true;
      const idsede = this.$store.state.CARGO.sede.id;
      const iduniversidad = this.$store.state.convenio.id;
      window.console.log(idsede, iduniversidad);
      const pros = await getProgramas(this, idsede, iduniversidad, this.gestion);
      this.programas = pros;
      this.loading_programas = false;
    },
    async listarDatos() {
      this.isLoading = true;
      const idprograma = this.programa.id;
      // const anio = this.gestion;
      // const sede = this.$store.state.CARGO.sede.id;
      // window.console.log(idprograma, anio, sede);
      const data = await getDatos(idprograma);

      this.headers = data.headers;
      this.datos = data.datos;
      this.totales = data.totales;
      this.isLoading = false;
    },
  },
  async mounted() {
    this.listarGestiones();
    this.headers = getHeaders();
    this.datos = [];
    // this.listarDatos();
  },
};
</script>
